module.exports = __webpack_public_path__ + "static/_0004_LALAACE-883ded3fa4e541dcb4782431284fdf59.jpg";